import React from "react";
import PropTypes from "prop-types";
import { GetIcon } from "../icons/GetIcon.js";

export default class EventCard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    const { index, loading } = this.props;

    if (0 == index && !loading) {
      this.itemWrapper.focus();
    }
  }

  renderPeopleList(people, label) {
    return (<div className="digest-card__items">
        <span className="digest-card__label">
          { label } -&nbsp;
        </span>
        { people.map((person, i) => {
          let spacer = i < people.length - 2
            ? ", "
            : i === people.length - 2
              ? " & "
              : "";
          return <span key={i} dangerouslySetInnerHTML={{ __html: person + spacer }}></span>;
        }) }
      </div>);
  }

  render() {
    const { abstract, conference, imageurl, publisheddate, enddate, displaydate, conferenceAnnounced, title, type, url, displaytypename } = this.props;

    const ariaLabel = "Read the full article on " + title;
    
    return (
      <div className="event-card event-card--right-image">
        { imageurl && <img className="event-card__image" src={ imageurl } alt="" />}
        { title && <div className="event-card__title"><a ref={el => (this.itemWrapper = el)} href={ url }>{ title }</a></div>}
        <div className="event-card__date">
          { displaydate && <span className="event-card__label">{ displaydate }</span> } - { displaytypename && <span className="event-card__label">{ displaytypename }</span> }
          { conferenceAnnounced && GetIcon('check') }
          { conferenceAnnounced && <span className="program">Program</span> }
        </div>
        { conference && conference.length > 0 && this.renderPeopleList(conference, "Associated Conference") }
      </div>
    );
  }
}

const { array, bool, func, number, string } = PropTypes;

EventCard.propTypes= {
  abstract: string,
  conference: array,
  imageurl: string,
  index: number,
  loading: bool,
  publisheddate: string,
  enddate: string,
  conferenceAnnounced: bool,
  title: string,
  type: string,
  url: string,
  displaydate: string,
  displaytypename: string
};
